var exports = {
  "O8": "TestimonialsSection__07eeeS",
  "if": "TestimonialsSection__testimonials__AC8HPy",
  "ZN": "TestimonialsSection__gridContent__-iEXoX",
  "Y6": "TestimonialsSection__gridContent--mobileFullWidth__f8LZIq",
  "SO": "TestimonialsSection__gridColumn__L7Kfxj",
  "NL": "TestimonialsSection__logoMarquee__LLa-Zn",
  "aZ": "TestimonialsSection__Spacer__8Ckk9l",
};

module.exports = exports;
